const isScrollable = (node: Element) => {
  if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
    return false;
  }
  const style = getComputedStyle(node);
  return ['overflow', 'overflow-x', 'overflow-y'].some((propertyName) => {
    const value = style.getPropertyValue(propertyName);
    return value === 'auto' || value === 'scroll';
  });
};

/** Traverses DOM from node up until it finds a scrollable parent */
export const getScrollParent = ({ parentElement }: Element): Element => {
  if (!parentElement) return document.scrollingElement ?? document.documentElement;

  return parentElement && isScrollable(parentElement)
    ? parentElement
    : getScrollParent(parentElement);
};
